"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapDescriptor = void 0;
const object_1 = require("../../utils/object");
const mapDescriptor = (descriptor, map) => (0, object_1.mapObject)(descriptor, ([rawKey]) => {
    const key = rawKey;
    return map([key, descriptor[key]]);
});
exports.mapDescriptor = mapDescriptor;
//# sourceMappingURL=descriptors.js.map